import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { HippoApiService } from 'services/hippoApi';
import { ModalService } from 'common/source/services/modal';

const module = angular.module('mobile-escrow-pay-now', []);

interface MobileCcPayNowData {
    policyId: PolicyId;
    setSuccessMessage: (successMessage: string, showSaveAsDefaultPaymentMethodQuestion: boolean) => void;
    closePayNow: () => void;
}

interface MobileCcPayNow extends angular.IStrictController {
    data: MobileCcPayNowData;
    close: () => void;
}

module.component('mobileEscrowPayNow', {
    template: template,
    bindings: {
        data: '<'
    },
    controller: function(
        this: MobileCcPayNow,
        hippoApiService: HippoApiService,
        modalService: ModalService,
        $scope: angular.IScope
    ) {
        this.$onInit = () => {
            $scope.$on('closePaymentEditSection', this.close);
        };

        this.close = () => {
            modalService.closeAllDialogs();
        };
    }
});

export { module };
